<template>
    <div class="g-container-box">
        <el-row class="g-header-container">
            <el-col :span="3">
                <div class="g-header-left">熟客控制台</div>
            </el-col>
            <el-col :span="16">
                <nav-head navSel="4"></nav-head>
            </el-col>
            <el-col :span="5">
                <op-head></op-head>
            </el-col>
        </el-row>
        <el-row class="g-view-container">
            <el-col :span="3" class="g-menu-container">
                <sidebar navType="4" defaultSel="1"></sidebar>
            </el-col>
            <el-col :span="21" class="g-center-container">

                <div class="goods_head">
                    <div class="head_li">
                        <p class="head_wt">商品</p>
                    </div>
                    <div class="head_li">所属分类</div>
                    <div class="head_li">品牌</div>
                    <div class="head_li">牌价</div>
                    <div class="head_li">操作</div>
                </div>

                <div class="goods_col" v-for="(item, index) in listData" :key="index">
                    <div class="col_li">
                        <div class="mdb_pic">
                            <div class="pic_img">
                                <img :src="JSON.parse(item.commodityPhoto)[0]">
                            </div>
                            <div class="pic_info">
                                <p class="info_tit">{{ item.commodityName }}</p>
                                <p><span>货号：</span>{{ item.commodityCode }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="col_li">{{ item.classification }}</div>
                    <div class="col_li">{{ item.brand }}</div>
                    <div class="col_li">{{ item.price }}</div>
                    <div class="col_li">
                        <p v-if="item.status">
                            <span class="li_clo1" v-if="item.status == 1">已通过</span>
                            <span class="li_clo2" v-if="item.status == 2">未通过</span>
                        </p>
                        <el-button v-else type="text" @click="delectQx(item)">审核</el-button>
                    </div>
                </div>

            </el-col>
        </el-row>

        <el-dialog title="审核" :visible.sync="dialog" width="30%">
            <div class="order_input1">
                <template>
                    <el-radio v-model="status" label="1">通过</el-radio>
                    <el-radio v-model="status" label="2">拒绝</el-radio>
                </template>
            </div>
            <!-- <div v-if="status == 1">
                <el-radio v-model="reco" label="0">不推荐</el-radio>
                <el-radio v-model="reco" label="1">推荐内容</el-radio>
            </div>
            <div v-if="status == 2">
                <el-radio v-model="isFreeze" label="0">不冻结权限</el-radio>
                <el-radio v-model="isFreeze" label="1">冻结权限</el-radio>
            </div> -->
            <span slot="footer" class="dialog_footer">
                <el-button type="primary" @click="sendApi">确认</el-button>
                <el-button @click="dialog = false">取消</el-button>
            </span>
        </el-dialog>
    </div>
</template>
  
<script>

var util = require("@/common/util.js");
import { API_GOOLIST, API_SHHESPI } from "../../assets/js/api.js";
import sidebar from '../../components/sidebar'
import navHead from "../../components/navHead";
import opHead from "../../components/opHead.vue";
export default {
    components: {
        sidebar,
        navHead,
        opHead
    },
    data() {
        return {
            listData: '',
            dialog: false,
            status: '1',  // 1通过，2拒绝
            reco: '0',  // 0不推，1推荐
            isFreeze: '0', // 0不冻结，1推荐

            commodityId: '',
            merchantId: ''
        }
    },
    created() {
        this.getListData()
    },
    methods: {
        getListData() {
            let params = {}
            util.getData(API_GOOLIST, params, (res) => {
                this.listData = res.data.data
            })
        },
        delectQx(e) {
            this.commodityId = e.commodityId
            this.merchantId = e.merchantId
            this.dialog = true
        },
        sendApi() {  // 添加权限
            let params = new URLSearchParams();

            params.append('commodityId', this.commodityId);
            params.append('merchantId', this.merchantId);
            params.append('status', this.status);
            // if (this.status == 1) {
            //     params.append('reco', this.reco);
            // } else {
            //     params.append('isFreeze', this.isFreeze);
            // }
            util.getData(API_SHHESPI, params, (res) => {
                console.log(res.data)
                this.dialog = false
                this.$message('操作成功')
                this.getListData()
            })
        },

        backAcount() {
            this.$confirm('确定退出登录?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                localStorage.removeItem("token");
                this.$router.push({ path: '/' });
                this.$message({
                    showClose: true,
                    message: '操作成功',
                    type: 'success'
                });
            }).catch(() => {
                console.log('已取消')
            })
        }
    }
}
</script>
  
<style lang="less">
.g-container-box {
    overflow: hidden;
}

.g-header-left {
    background-color: #5c6be8;
    color: #FFF;
    height: 60px;
    line-height: 60px;
    text-align: center;
}

.g-menu-container {
    height: 800px;
    background-color: #fff;
}

.g-header-right {
    background-color: #5c6be8;
    color: #FFF;
    padding-right: 40px;
    height: 60px;
    line-height: 60px;
    text-align: right;
}

.g-header-right span {
    margin: 0 10px;
    cursor: pointer;
}

.g-center-container {
    overflow: auto;
    height: 800px;
    background-color: #eff3f6;
    padding: 20px;
}

.nav_search {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 10px;
    margin-bottom: 30px;

    .nav_search_row {
        display: flex;
        flex-direction: row;
    }

    .nav_search_li {
        margin-right: 20px;
        width: 260px;
    }
}

.order_input1 {
    margin-bottom: 20px;
}

.goods_head {
    background-color: #ffffff;
    display: flex;
    flex-direction: row;
    padding: 10px 0;
    border: 1px solid #ebeef5;

    .head_wt {
        width: 270px;
    }

    .head_li {
        color: #232527;
        flex: 1;
        padding-left: 14px;
    }
}

.goods_col {
    background-color: #ffffff;
    display: flex;
    flex-direction: row;
    border: 1px solid #ebeef5;
    margin: 10px 0;

    .col_li {
        padding: 14px;
        flex: 1;
        padding-left: 14px;
        border-right: 1px solid #ebeef5;

        .li_clo1 {
            color: #67c23a;
        }

        .li_clo2 {
            color: #f56c6c;
        }
    }
}

.mdb_pic {
    display: flex;
    align-items: center;
    flex-direction: row;
    width: 260px;

    .pic_img {
        width: 80px;
        height: 80px;
        margin-right: 8px;
        border-radius: 4px;
        overflow: hidden;
        border: 1px solid #e7e7e7;

        img {
            width: 100%;
            height: auto;
        }
    }

    .pic_info {
        flex: 1;
        height: 80px;

        .info_tit {
            padding-bottom: 10px;
        }
    }
}

.bmo_tab {
    .tab_row {
        display: flex;
        flex-direction: row;
        // flex-wrap: wrap;
    }

    .tab_img {
        width: 60px;
        height: 60px;
        border-radius: 6px;
        background-color: #f2f2f2;
        margin-right: 12px;
    }
}</style>


// WEBPACK FOOTER //
// src/pages/goods/index.vue